import './module/coman-consent-manager-configuration-page'
import './component/coman-consent-manager-settings-icon';

import deDE from './snippet/de-DE.json';
import enGB from './snippet/en-GB.json';

Shopware.Locale.extend('de-DE', deDE);
Shopware.Locale.extend('en-GB', enGB);
